export default __webpack_public_path__ + "static/media/jenkins.2a3d6b1c.svg";